export default __webpack_public_path__ + "static/media/linear-template.905fc604.png";